"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const UserIcon = createIcon({
  displayName: "UserIcon",
  viewBox: "0 0 45 45",
  path: (
    <>
      <path
        d="M8.66,33.97c1.91-1.46,4.05-2.62,6.41-3.46,2.36-.84,4.84-1.27,7.43-1.27s5.06.42,7.42,1.27c2.36.84,4.5,2,6.41,3.46,1.31-1.54,2.33-3.28,3.07-5.23.73-1.95,1.1-4.03,1.1-6.24,0-4.99-1.75-9.23-5.26-12.74-3.51-3.51-7.75-5.26-12.74-5.26s-9.23,1.75-12.74,5.26c-3.51,3.51-5.26,7.75-5.26,12.74,0,2.21.37,4.29,1.1,6.24.73,1.95,1.75,3.69,3.07,5.23ZM22.5,24.75c-2.21,0-4.08-.76-5.6-2.28-1.52-1.52-2.28-3.38-2.28-5.6s.76-4.08,2.28-5.6c1.52-1.52,3.38-2.28,5.6-2.28s4.08.76,5.6,2.28c1.52,1.52,2.28,3.38,2.28,5.6s-.76,4.08-2.28,5.6c-1.52,1.52-3.38,2.28-5.6,2.28ZM22.5,45c-3.11,0-6.04-.59-8.77-1.77-2.74-1.18-5.12-2.78-7.14-4.81-2.03-2.03-3.63-4.41-4.81-7.14-1.18-2.74-1.77-5.66-1.77-8.77s.59-6.04,1.77-8.77c1.18-2.74,2.78-5.12,4.81-7.14,2.02-2.03,4.41-3.63,7.14-4.81,2.74-1.18,5.66-1.77,8.77-1.77s6.04.59,8.77,1.77c2.74,1.18,5.12,2.78,7.14,4.81,2.02,2.02,3.63,4.41,4.81,7.14,1.18,2.74,1.77,5.66,1.77,8.77s-.59,6.04-1.77,8.77c-1.18,2.74-2.78,5.12-4.81,7.14-2.03,2.02-4.41,3.63-7.14,4.81-2.74,1.18-5.66,1.77-8.77,1.77ZM22.5,40.5c1.99,0,3.86-.29,5.62-.87,1.76-.58,3.38-1.42,4.84-2.5-1.46-1.09-3.08-1.92-4.84-2.5-1.76-.58-3.64-.87-5.62-.87s-3.86.29-5.62.87c-1.76.58-3.38,1.42-4.84,2.5,1.46,1.09,3.07,1.92,4.84,2.5,1.76.58,3.64.87,5.62.87ZM22.5,20.25c.98,0,1.78-.32,2.42-.96.64-.64.96-1.44.96-2.42s-.32-1.78-.96-2.42c-.64-.64-1.44-.96-2.42-.96s-1.78.32-2.42.96c-.64.64-.96,1.44-.96,2.42s.32,1.78.96,2.42c.64.64,1.44.96,2.42.96Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default UserIcon;
